import { Component, Input } from '@angular/core';
import { RoleMatrix } from '../../../../helpers';

@Component({
    selector: 'app-breadcrumb-signage-manage',
    templateUrl: './breadcrumb.signage.manage.component.html'
})

export class BreadcrumbSignageManageComponent {
    @Input() companyId: number;
    @Input() kioskId: number;
    @Input() facilityId: number;
    roleMatrix: RoleMatrix;

    constructor() {
        this.roleMatrix = new RoleMatrix();
    }
}
